export default __webpack_public_path__ + "static/open-sans-v15-latin-700-2509c35b0cfc629f81e50ce5ef62e4d3.woff";